import React from "react";
import notify from "devextreme/ui/notify";
import Form, {
  SimpleItem,
  GroupItem,
  Label,
  EmptyItem,
} from "devextreme-react/form";
import "devextreme-react/text-area";
import UserInfo from "../../UserInfo";
import {
  inserirOuAtualizar,
  criarContribuinteDs,
  criarImovelDs,
  criarNaturezaOperacaoDs,
  criarItbiDs,
  criarItbiLancamentosDs,
} from "../../DataSources";
import { Button, ScrollView } from "devextreme-react";
import sysCodigoDescricao from "../../components/sysCodigoDescricao";
import ContribuinteBox from "../contribuintes/ContribuinteBox";
import ImovelBox from "../imovel/ImovelBox";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import DataSource from "devextreme/data/data_source";
import uiInfo from "../../ui-info";
import Memoria from "../../Memoria";
import { abrirDetalhe } from "../../lancamentosUtils";
import date_box from "devextreme/ui/date_box";
import ShowError from "../../AppServices";

const _versaoCadastro = 1;
let _cadastroCorrente = undefined;
let _cancelando = false;

const template = {
  id: undefined,
  prefeituraId: undefined,
  compradorId: undefined,
  vendedorId: undefined,
  imovelId: undefined,
  naturezaDaOperacaoId: undefined,
  ano: new Date().getFullYear(),
  areaDoLote: undefined,
  areaEdificada: undefined,
  competencia: undefined,
  data: new Date(),
  dataDeVencimento: undefined,
  historico: undefined,
  limiteLeste: undefined,
  limiteNorte: undefined,
  limiteOeste: undefined,
  limiteSul: undefined,
  localizacao: undefined,
  numero: undefined,
  obs: undefined,
  pago: undefined,
  situacao: "N",
  tipoDeItbi: 0,
  unidadeAreaEdificada: undefined,
  unidadeAreaLote: undefined,
  valorDaOperacao: 0,
  valorDeCobranca: 0,
  valorVenal: 0,
  preview: false,
  valorFinanciado: 0,
  valorNaoFinanciado: 0,
  popupCompradorVisivel: false,
  popupVendedorVisivel: false,
  popupImovelVisivel: false,
};

export default class ItbiForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.saidaProgramada = false;
    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.state = {};
    this.contribuinteDs = criarContribuinteDs();
    this.naturezasDs = criarNaturezaOperacaoDs();
    this.imovelDs = criarImovelDs();
    this.naturezaOperacao = [];
    this.verificaCampos = this.verificaCampos.bind(this);
    this.itbiDs = criarItbiDs();
    this.itbiLancamentoDs = criarItbiLancamentosDs();
    this.cancelando = false;

    this.naturezaOperaacoStore = new DataSource({
      store: {
        data: this.naturezaOperacao,
        type: "array",
        key: "id",
      },
    });

    //Funções do comprador
    /*
    /*
    */
    this.setCompradorId = this.setCompradorId.bind(this);
    this.setNomeComprador = this.setNomeComprador.bind(this);
    this.pesquisarComprador = this.pesquisarComprador.bind(this);
    this.onCompradorSelecionadoPesquisa =
      this.onCompradorSelecionadoPesquisa.bind(this);
    this.compradorBoxRef = React.createRef();
    this.renderComprador = sysCodigoDescricao(
      () => this.state.compradorId,
      this.setCompradorId,
      () => this.state._uiNomeComprador,
      this.pesquisarComprador
    );
    this.setNomeCompradorErro = this.setNomeCompradorErro.bind(this);
    this.atualizarNomeComprador = this.atualizarNomeComprador.bind(this);
    /*
    /*
    */
    //Fim da funções do comprador

    //Funções do vendedor
    /*
    /*
    */
    this.setVendedorId = this.setVendedorId.bind(this);
    this.setNomeVendedor = this.setNomeVendedor.bind(this);
    this.pesquisarVendedor = this.pesquisarVendedor.bind(this);
    this.onVendedorSelecionadoPesquisa =
      this.onVendedorSelecionadoPesquisa.bind(this);
    this.vendedorBoxRef = React.createRef();
    this.renderVendedor = sysCodigoDescricao(
      () => this.state.vendedorId,
      this.setVendedorId,
      () => this.state._uiNomeVendedor,
      this.pesquisarVendedor
    );
    this.setNomeVendedor = this.setNomeVendedor.bind(this);
    this.atualizarNomeVendedor = this.atualizarNomeVendedor.bind(this);
    /*
    /*
    */
    //Fim das funções do vendedor

    //Funções do imóvel
    /*
    /*
    */
    this.setImovelId = this.setImovelId.bind(this);
    this.setNomeImovel = this.setNomeImovel.bind(this);
    this.pesquisarImovel = this.pesquisarImovel.bind(this);
    this.onImovelSelecionadoPesquisa =
      this.onImovelSelecionadoPesquisa.bind(this);
    this.renderImovel = sysCodigoDescricao(
      () => this.state.imovelId,
      this.setImovelId,
      () => this.state._uiNomeImovel,
      this.pesquisarImovel
    );
    this.setNomeImovelErro = this.setNomeImovelErro.bind(this);
    this.atualizarNomeImovel = this.atualizarNomeImovel.bind(this);
    /*
   /*
   */
    //Fim da funções do imóvel

    this.tipoItbiOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      cancelButtonText: "Cancelar",
      placeholder: "Selecione...",
      dataSource: [
        { id: 0, descricao: "Com Cadastro" },
        { id: 1, descricao: "Sem Cadastro" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
      onValueChanged: (e) => this.setState({ tipoDeItbi: e.value }),
    };

    this.posicaoFiscalOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      cancelButtonText: "Cancelar",
      placeholder: "Selecione...",
      dataSource: [
        { id: "N", descricao: "Tributável" },
        { id: "M", descricao: "Imune" },
        { id: "I", descricao: "Isento" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.naturezaOperacaoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      searchPlaceholder: "Procurar",
      cancelButtonText: "Cancelar",
      noDataText: "Nenhum registo encontrado",
      placeholder: "Selecione",
      dataSource: this.naturezaOperaacoStore,
      valueExpr: "sequencial",
      displayExpr: "descricao",
      searchMode: "contains",
    };

    this.tipoCobrancaOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      cancelButtonText: "Cancelar",
      placeholder: "Selecione...",
      dataSource: [
        { id: 0, descricao: "Valor Venal" },
        { id: 1, descricao: "Valor Declarado" },
        { id: 2, descricao: "Valor Avalidado" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
      onValueChanged: (e) =>
        this.setState({
          valorDeCobranca: e.value,
          valorNaoFinanciado: this.verificaCampos(e.value),
        }),
    };
  }

  componentWillUnmount() {
    _cadastroCorrente = _cancelando ? undefined : this.state;
    if (_cadastroCorrente != undefined) {
      Memoria.emEdicao(this.props.location, _cadastroCorrente, _versaoCadastro);
    }
  }

  verificaCampos(e) {
    if (e === 0) {
      return this.state.valorVenal - this.state.valorFinanciado;
    }
    if (e === 1) {
      return this.state.valorDeclarado - this.state.valorFinanciado;
    }
    if (e === 2) {
      return this.state.valorAvaliado - this.state.valorFinanciado;
    }
  }

  //Funções do comprador
  /*
  /*
  */

  setCompradorId(data) {
    this.setState({ compradorId: data.value });
    this.atualizarNomeComprador();
  }

  atualizarNomeComprador() {
    this.contribuinteDs
      .load({ filter: [["sequencial", "=", this.state.compradorId]] })
      .then((result) => {
        console.log(result);
        if (result.length !== 0) {
          this.setNomeComprador(result[0]);
        } else {
          this.setNomeComprador(undefined);
        }
      })
      .catch((_) => this.setNomeCompradorErro());
  }

  setNomeComprador(comprador) {
    if (comprador === undefined) {
      this.setState({ _uiNomeComprador: "" });
    } else {
      this.setState({ _uiNomeComprador: comprador.nome });
    }
  }

  setNomeCompradorErro() {
    this.setState({ _uiNomeComprador: "<<ERRO>>" });
  }

  onCompradorSelecionadoPesquisa(e) {
    this.setState({
      compradorId: e.row.data.sequencial,
      popupCompradorVisivel: false,
    });
    this.atualizarNomeComprador();
  }

  pesquisarComprador() {
    this.compradorBoxRef.current.limparFiltro();
    this.setState({ popupCompradorVisivel: true });
  }
  /*
  /*
  */
  //Fim da funções do comprador

  //Funções do vendedor
  /*
  /*
  */
  setVendedorId(data) {
    this.setState({ vendedorId: data.value });
    this.atualizarNomeVendedor();
  }

  atualizarNomeVendedor() {
    this.contribuinteDs
      .load({ filter: [["sequencial", "=", this.state.vendedorId]] })
      .then((result) => {
        console.log(result);
        if (result.length !== 0) {
          this.setNomeVendedor(result[0]);
        } else {
          this.setNomeVendedor(undefined);
        }
      })
      .catch((_) => this.setNomeVendedorErro());
  }

  setNomeVendedor(resposavel) {
    if (resposavel === undefined) {
      this.setState({ _uiNomeVendedor: "" });
    } else {
      this.setState({ _uiNomeVendedor: resposavel.nome });
    }
  }

  setNomeVendedorErro() {
    this.setState({ _uiNomeVendedor: "<<ERRO>>" });
  }

  onVendedorSelecionadoPesquisa(e) {
    this.setState({
      vendedorId: e.row.data.sequencial,
      popupVendedorVisivel: false,
    });
    this.atualizarNomeVendedor();
  }

  pesquisarVendedor() {
    this.vendedorBoxRef.current.limparFiltro();
    this.setState({ popupVendedorVisivel: true });
  }
  /*
  /*
  */
  //Fim das funções do vendedor

  //Funções do imóvel
  /*
  /*
  */

  setImovelId(data) {
    this.setState({ imovelId: data.value });
    this.atualizarNomeImovel();
  }

  atualizarNomeImovel() {
    this.imovelDs
      .load({ filter: [["sequencial", "=", this.state.imovelId]] })
      .then((result) => {
        console.log(result);
        if (result.length !== 0) {
          this.setNomeImovel(result[0]);
        } else {
          this.setNomeImovel(undefined);
        }
      })
      .catch((_) => this.setNomeImovelErro());
  }

  setNomeImovel(imovel) {
    console.log("imovel selecionado");
    if (imovel === undefined) {
      this.setState({ _uiNomeImovel: "", localizacao: "" });
    } else {
      this.setState({
        _uiNomeImovel: imovel.cartografiaFormatada,
        localizacao: imovel.enderecoSemCidade,
        areaDoLote: imovel.areaLote,
        areaEdificada: imovel.areaEdificada,
        unidadeAreaLote: "m²",
        unidadeAreaEdificada: "m²",
      });
    }
  }

  setNomeImovelErro() {
    this.setState({ _uiNomeImovel: "<<ERRO>>" });
  }

  onImovelSelecionadoPesquisa(e) {
    this.setState({
      imovelId: e.row.data.sequencial,
      popupImovelVisivel: false,
    });
    this.atualizarNomeImovel();
  }

  pesquisarImovel() {
    this.setState({ popupImovelVisivel: true });
  }
  /*
/*
*/
  //Fim da funções do imóvel

  async componentDidMount() {

    const naturezas = await this.naturezasDs.load();

    if (naturezas) {
      for (let natureza of naturezas) {
        this.naturezaOperacao.push(natureza);
      }
    }

    if (this.props.match.params.id !== undefined) {
      this.itbiLancamentoDs
        .load({ filter: [["sequencial", "=", this.props.match.params.id]] })
        .then((response) => {
          if (response.length < 1) {
            notify("Registro não encontrado.", "error");
            this.props.history.goBack();
          }

          const data = response[0];
          console.log("resp itbi", data);

          let novoEstado = {
            id: data.id,
            sequencial: data.sequencial,
            _uiNumero: data.numeroCompleto,
            prefeituraId: data.prefeituraId,
            compradorId: data.detalheItbi.comprador.sequencial,
            _uiNomeComprador: data.detalheItbi.comprador.nome,
            vendedorId: data.detalheItbi.vendedor.sequencial,
            _uiNomeVendedor: data.detalheItbi.vendedor.nome,
            imovelId:
              data.imovel != undefined ? data.imovel.sequencial : undefined,
            _uiNomeImovel:
              data.imovel != undefined
                ? data.imovel.cartografiaFormatada
                : undefined,
            naturezaDaOperacaoId:
              data.detalheItbi.naturezaDeOperacao.sequencial,
            ano: data.ano,
            areaDoLote: data.detalheItbi.areaDoLote,
            areaEdificada: data.detalheItbi.areaEdificada,
            competencia: data.competenciaLancamento,
            data: data.dataLancamento,
            dataDeVencimento: data.vencimentoAlvara,
            historico: data.historico,
            limiteLeste: data.detalheItbi.limiteLeste,
            limiteNorte: data.detalheItbi.limiteNorte,
            limiteOeste: data.detalheItbi.limiteOeste,
            limiteSul: data.detalheItbi.limiteSul,
            localizacao: data.detalheItbi.localizacao,
            numero: data.numeroLancamento,
            obs: data.obsLancamento,
            situacao: data.situacaoStr,
            tipoDeItbi: data.detalheItbi.tipoDeImovel,
            unidadeAreaEdificada: data.detalheItbi.unidadeAreaEdificada,
            unidadeAreaLote: data.detalheItbi.unidadeAreaLote,
            valorDaOperacao: data.detalheItbi.valorDaOperacao,
            valorDeCobranca: data.detalheItbi.valorDeCobranca,
            valorVenal: data.detalheItbi.valorVenal,
            preview: false,
            valorFinanciado: data.detalheItbi.valorFinanciado,
            valorNaoFinanciado: data.detalheItbi.valorNaoFinanciado,
            popupCompradorVisivel: false,
            popupVendedorVisivel: false,
            popupImovelVisivel: false,
            tipoDeItbi: data.detalheItbi.tipoDeImovel,
          };
          this.setState(novoEstado);
        });
    } else {
      _cadastroCorrente = Memoria.resturarEstado(
        this.props.location,
        _cadastroCorrente,
        _versaoCadastro
      );

      const dataCorrente = new Date();

      if (_cadastroCorrente == undefined) {
        this.setState({
          ...template,
          ano: dataCorrente.getFullYear(),
          exercicio: dataCorrente.getFullYear(),
          prefeituraId: UserInfo.getPrefeitura(),
        });
      } else {
        this.setState({
          ..._cadastroCorrente,
          prefeituraId: UserInfo.getPrefeitura(),
        });
      }
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <form>
            <Form formData={this.state} colCount={3}>
              <GroupItem caption="LANÇAMENTO DE ITBI" colSpan={3} colCount={4}>
                <SimpleItem
                  colSpan={1}
                  dataField={"_uiNumero"}
                  editorOptions={{ readOnly: true }}
                >
                  <Label text="Número" />
                </SimpleItem>
                <SimpleItem
                  dataField={"data"}
                  editorType={"dxDateBox"}
                  colSpan={1}
                  editorOptions={{ width: "100%", useMaskBehavior: true }}
                >
                  <Label text="Data" />
                </SimpleItem>
                <SimpleItem colSpan={1} dataField={"competencia"}>
                  <Label text="Competência" />
                </SimpleItem>
                <SimpleItem
                  dataField={"dataDeVencimento"}
                  editorType={"dxDateBox"}
                  colSpan={1}
                  editorOptions={{ width: "100%", useMaskBehavior: true }}
                >
                  <Label text="Vencimento" />
                </SimpleItem>
                <EmptyItem colSpan={2}></EmptyItem>
              </GroupItem>

              <GroupItem
                caption="ADQUIRENTE E TRANSMITENTE"
                colSpan={3}
                colCount={1}
              >
                <SimpleItem colSpan={1} component={this.renderVendedor}>
                  <Label text="Vendedor" />
                </SimpleItem>
                <SimpleItem colSpan={1} component={this.renderComprador}>
                  <Label text="Comprador" />
                </SimpleItem>
              </GroupItem>

              <GroupItem caption="IMÓVEL" colSpan={3} colCount={4}>
                <SimpleItem
                  colSpan={2}
                  dataField={"tipoDeItbi"}
                  editorType={"dxSelectBox"}
                  editorOptions={this.tipoItbiOptions}
                >
                  <Label text="Tipo de Imóvel" />
                </SimpleItem>
                <EmptyItem colSpan={2} />
                <SimpleItem
                  colSpan={4}
                  component={this.renderImovel}
                  visible={this.state.tipoDeItbi === 1 ? false : true}
                >
                  <Label text="Imóvel" />
                </SimpleItem>
                <SimpleItem
                  colSpan={4}
                  dataField={"localizacao"}
                  editorType={"dxTextArea"}
                  editorOptions={{
                    readOnly: this.state.tipoDeItbi === 1 ? false : true,
                    height: "80px",
                  }}
                >
                  <Label text="Localização" />
                </SimpleItem>
                <SimpleItem
                  colSpan={1}
                  dataField={"areaDoLote"}
                  editorType={"dxNumberBox"}
                  editorOptions={{
                    readOnly: this.state.tipoDeItbi === 1 ? false : true,
                    format: uiInfo.formatoNumerico.n2,
                  }}
                  cssClass={"txtNumerico"}
                >
                  <Label text="Área do Lote" />
                </SimpleItem>
                <SimpleItem
                  colSpan={1}
                  editorOptions={{
                    readOnly: this.state.tipoDeItbi === 1 ? false : true,
                  }}
                  dataField={"unidadeAreaLote"}
                >
                  <Label text="Unid. Medida" />
                </SimpleItem>
                <SimpleItem
                  colSpan={1}
                  dataField={"areaEdificada"}
                  editorType={"dxNumberBox"}
                  editorOptions={{
                    readOnly: this.state.tipoDeItbi === 1 ? false : true,
                    format: uiInfo.formatoNumerico.n2,
                  }}
                  cssClass={"txtNumerico"}
                >
                  <Label text="Área Edificada" />
                </SimpleItem>
                <SimpleItem
                  colSpan={1}
                  dataField={"unidadeAreaEdificada"}
                  editorOptions={{
                    readOnly: this.state.tipoDeItbi === 1 ? false : true,
                  }}
                >
                  <Label text="Unid. Medida" />
                </SimpleItem>
              </GroupItem>

              <GroupItem caption="VALORES E IMPOSTOS" colSpan={3} colCount={3}>
                <SimpleItem
                  dataField={"naturezaDaOperacaoId"}
                  editorType={"dxSelectBox"}
                  editorOptions={this.naturezaOperacaoOptions}
                  colSpan={3}
                >
                  <Label text="Natureza da Operação" />
                </SimpleItem>

                <SimpleItem
                  colSpan={1}
                  dataField={"valorDaOperacao"}
                  editorType={"dxNumberBox"}
                  cssClass="box-n2"
                  editorOptions={{
                    format: uiInfo.formatoNumerico.n2,
                    onValueChanged: (e) => {
                      this.setState({
                        valorDaOperacao: e.value,
                        valorNaoFinanciado:
                          e.value - this.state.valorFinanciado,
                      });
                    },
                  }}
                >
                  <Label text="Valor da Operação" />
                </SimpleItem>

                <SimpleItem
                  colSpan={1}
                  dataField={"valorFinanciado"}
                  editorType={"dxNumberBox"}
                  cssClass="box-n2"
                  editorOptions={{
                    format: uiInfo.formatoNumerico.n2,
                    onValueChanged: (e) =>
                      this.setState({
                        valorNaoFinanciado:
                          this.state.valorDaOperacao - e.value,
                      }),
                  }}
                >
                  <Label text="Valor Financiado (R$)" />
                </SimpleItem>
                <SimpleItem
                  colSpan={1}
                  dataField={"valorNaoFinanciado"}
                  editorType={"dxNumberBox"}
                  cssClass="box-n2"
                  editorOptions={{
                    readOnly: true,
                    format: { type: "fixedPoint", precision: 2 },
                  }}
                >
                  <Label text="Valor Não Financiado (R$)" />
                </SimpleItem>
                <EmptyItem colSpan={2}></EmptyItem>
              </GroupItem>
              <GroupItem
                caption="OBSERVAÇÃO DO AVALIADOR"
                colSpan={3}
                colCount={3}
              >
                <SimpleItem
                  dataField={"obs"}
                  editorType={"dxTextArea"}
                  editorOptions={{ height: "120px" }}
                  colSpan={3}
                >
                  <Label visible={false} />
                </SimpleItem>
              </GroupItem>

              <GroupItem caption="LIMITES DO IMÓVEL" colSpan={3} colCount={3}>
                <SimpleItem
                  dataField={"limiteNorte"}
                  editorType={"dxTextArea"}
                  editorOptions={{ height: "80px" }}
                  colSpan={3}
                >
                  <Label text="Limite Norte" />
                </SimpleItem>
                <SimpleItem
                  dataField={"limiteSul"}
                  editorType={"dxTextArea"}
                  editorOptions={{ height: "80px" }}
                  colSpan={3}
                >
                  <Label text="Limite Sul" />
                </SimpleItem>
                <SimpleItem
                  dataField={"limiteLeste"}
                  editorType={"dxTextArea"}
                  editorOptions={{ height: "80px" }}
                  colSpan={3}
                >
                  <Label text="Limite Leste" />
                </SimpleItem>
                <SimpleItem
                  dataField={"limiteOeste"}
                  editorType={"dxTextArea"}
                  editorOptions={{ height: "80px" }}
                  colSpan={3}
                >
                  <Label text="Limite Oeste" />
                </SimpleItem>
              </GroupItem>
            </Form>
            <div
              style={{
                display: "flex",
                marginTop: "25px",
                justifyContent: "center",
                alignContent: "center",
                justifyItems: "center",
                alignItems: "center",
              }}
            >
              <div style={{ display: "inline-block" }}>
                <Button
                  width={120}
                  text="Confirmar"
                  type="success"
                  onClick={this.ok}
                />
              </div>
              <div style={{ marginLeft: "10px" }}>
                <Button text="Cancelar" onClick={this.cancel} width={120} />
              </div>
            </div>
          </form>
          <Popup
            visible={this.state.popupCompradorVisivel}
            onHiding={() => this.setState({ popupCompradorVisivel: false })}
            dragEnabled={false}
            closeOnOutsideClick={true}
            showCloseButton={true}
            showTitle={true}
            width={"90%"}
            height={"90%"}
            title="Pesquisar Adquirente"
          >
            <ScrollView showScrollbar={"always"}>
              <ContribuinteBox
                onSelecionado={this.onCompradorSelecionadoPesquisa}
                ref={this.compradorBoxRef}
              />
            </ScrollView>

            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Fechar",
                type: "default",
                width: 150,
                onClick: () => this.setState({ popupCompradorVisivel: false }),
              }}
            ></ToolbarItem>
          </Popup>
          <Popup
            visible={this.state.popupVendedorVisivel}
            onHiding={() => this.setState({ popupVendedorVisivel: false })}
            dragEnabled={false}
            closeOnOutsideClick={true}
            showCloseButton={true}
            showTitle={true}
            width={"90%"}
            height={"90%"}
            title="Pesquisar Transmitente"
          >
            <ScrollView showScrollbar={"always"}>
              <ContribuinteBox
                onSelecionado={this.onVendedorSelecionadoPesquisa}
                ref={this.vendedorBoxRef}
              />
            </ScrollView>

            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Fechar",
                type: "default",
                width: 150,
                onClick: () => this.setState({ popupVendedorVisivel: false }),
              }}
            ></ToolbarItem>
          </Popup>
          <Popup
            visible={this.state.popupImovelVisivel}
            onHiding={() => this.setState({ popupImovelVisivel: false })}
            dragEnabled={false}
            closeOnOutsideClick={true}
            showCloseButton={true}
            showTitle={true}
            width={"90%"}
            height={"90%"}
            title="Pesquisar Imóvel"
          >
            <ScrollView showScrollbar={"always"}>
              <ImovelBox onSelecionado={this.onImovelSelecionadoPesquisa} />
            </ScrollView>

            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Fechar",
                type: "default",
                width: 150,
                onClick: () => this.setState({ popupImovelVisivel: false }),
              }}
            ></ToolbarItem>
          </Popup>
        </div>
      </React.Fragment>
    );
  }

  ok() {
    const entidade = this.state;
    console.log(entidade);
    inserirOuAtualizar(this.itbiLancamentoDs, entidade)
      .then((data) => {
        notify("ITBI registrado com sucesso.", "success");
        _cadastroCorrente = undefined;
        _cancelando = true;
        Memoria.removerEdicao(this.props.location);
        abrirDetalhe(this.props.history, data);
      });
  }

  cancel() {
    _cadastroCorrente = undefined;
    _cancelando = true;
    notify("Operação cancelada", "warning");
    Memoria.removerEdicao(this.props.location);
    this.props.history.goBack();
  }
}
